import React, { useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { StyledDialog, FlexEndContainer, FlexDialogContent, FlexColumn } from '../styles/Containers'
import { ErrorMessage, WarningMessage } from '../common/UserMessage'
import Button, { SecondaryButton } from '../common/Button'
import { BoldFormTitle, MedBodyText } from '../styles/Text'

function CombineCategoryButton({ categoryId, onSuccess = () => {} }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => {
    setIsVisible(false)
    setError(false)
    setIsLoading(false)
  }

  async function handleConfirm() {
    setIsLoading(true)
    setError(false)

    axios
      .post(`/category/${categoryId}/combine`)
      .then(({ data }) => {
        handleClose()
        onSuccess(data.data)
      })
      .catch(e => {
        console.error('Failed to start combine files workflow', e)
        setError(true)
        setIsLoading(false)
      })
  }

  return (
    <>
      <Button onClick={handleOpen}>Combine Files</Button>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <FlexDialogContent>
          <FlexColumn>
            <BoldFormTitle>Combine Category Files</BoldFormTitle>
            <WarningMessage>
              <MedBodyText>Combining a category is irreversible, and you will no longer be able to add files to this category.</MedBodyText>
            </WarningMessage>
            {error && <ErrorMessage>Hm, an error occurred. Please try again.</ErrorMessage>}
            <FlexEndContainer>
              <SecondaryButton onClick={handleClose} disabled={isLoading}>
                Cancel
              </SecondaryButton>
              <Button onClick={handleConfirm} loading={isLoading}>
                Combine
              </Button>
            </FlexEndContainer>
          </FlexColumn>
        </FlexDialogContent>
      </StyledDialog>
    </>
  )
}

CombineCategoryButton.propTypes = {
  categoryId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}

export default CombineCategoryButton
